export default "0c0259b823a8f770.svg"